/* eslint-disable react/prop-types */

import React from 'react';

import {SortableContainer, SortableElement} from 'react-sortable-hoc';

import useIntlFormat from '@/hooks/useIntlFormat';

import Cycle from './Cycle';

import './ContentRunners.less';

export function TopContentRunners({
  isSequenceDesignerRunning,
  isMaximumSequence,
  addSequence,
  openSequenceFile,
  saveSequenceFile,
  emptyOperations,
  operationChanged,
  onClickRepeatAll,
  repeatAll,
  clearSequence,
}) {
  const {formatMessage} = useIntlFormat();
  const disabledAddSequenceButton = !!(isSequenceDesignerRunning || isMaximumSequence);

  return (
    <div
      className={
        isSequenceDesignerRunning === true
          ? 'top-content-disabled top-content-sequence-runners middleAlign '
          : 'top-content-sequence-runners middleAlign'
      }
      disabled={isSequenceDesignerRunning}
    >
      <div
        className="div-3col"
        style={{justifyContent: 'flex-start'}}
      >
        <button
          type="button"
          onClick={addSequence}
          className="topMenuButton glyphicon glyphicon-plus"
          disabled={disabledAddSequenceButton}
        />
        <button
          type="button"
          onClick={openSequenceFile}
          className="topMenuButton glyphicon glyphicon-folder-open"
          disabled={isSequenceDesignerRunning}
        />
        <button
          type="button"
          onClick={saveSequenceFile}
          className="topMenuButton glyphicon glyphicon-floppy-disk"
          disabled={isSequenceDesignerRunning || emptyOperations || operationChanged === false}
        />
      </div>
      <div className="col-md-6">
        <div className="div-3col">
          <div className="parentRepeatAllText no-padding">
            <span
              className="repetAllText"
              disabled={isSequenceDesignerRunning}
            >
              {formatMessage({id: 'general.label.repeatAll'})}
            </span>
          </div>
          <input
            className="repeatInput"
            readOnly
            onClick={onClickRepeatAll}
            value={repeatAll}
            disabled={isSequenceDesignerRunning}
          />
          <div className="parentCrossText">
            <span
              className="crossText glyphicon glyphicon-remove"
              disabled={isSequenceDesignerRunning}
            />
          </div>
        </div>
      </div>
      <div className="col-md-1 center">
        <button
          type="button"
          onClick={clearSequence}
          className="clearSequence glyphicon glyphicon-trash"
          disabled={isSequenceDesignerRunning || emptyOperations}
        />
      </div>
    </div>
  );
}

const SortableItem = SortableElement(
  ({
    sequence,
    isSequenceDesignerRunning,
    removeSequence,
    updateSequenceState,
    updatePressureType,
    sequenceChange,
    updateTotalRepeat,
    onClickSequenceConfig,
    onChangeRepeatMode,
  }) => (
    <Cycle
      sequence={sequence}
      isSequenceDesignerRunning={isSequenceDesignerRunning}
      removeSequence={removeSequence}
      updateSequenceState={updateSequenceState}
      updatePressureType={updatePressureType}
      sequenceChange={sequenceChange}
      updateTotalRepeat={updateTotalRepeat}
      onClickSequenceConfig={onClickSequenceConfig}
      onChangeRepeatMode={onChangeRepeatMode}
    />
  ),
);

export const SortableList = SortableContainer(
  ({
    operations,
    isSequenceDesignerRunning,
    removeSequence,
    updateSequenceState,
    updatePressureType,
    sequenceChange,
    updateTotalRepeat,
    onClickSequenceConfig,
    onChangeRepeatMode,
  }) => (
    <div className="manualProfileList">
      {operations.map((sequence, index) => (
        // <div key={`item-${index}`}>
        <SortableItem
          // eslint-disable-next-line react/no-array-index-key
          key={`item-${index}`}
          index={index}
          sequence={sequence}
          isSequenceDesignerRunning={isSequenceDesignerRunning}
          removeSequence={removeSequence}
          updateSequenceState={updateSequenceState}
          updatePressureType={updatePressureType}
          sequenceChange={sequenceChange}
          updateTotalRepeat={updateTotalRepeat}
          onClickSequenceConfig={onClickSequenceConfig}
          onChangeRepeatMode={onChangeRepeatMode}
        />
        // </div>
      ))}
    </div>
  ),
);
